import request from '@/utils/request.js'
import Config from '@/config/app.js'
let wxUseUrl = Config.wxUseUrl;



/**
 * 学习首页-H5课程详情-购买结算-H5结算页
 * @param params
 * @returns {AxiosPromise}
 *
 *
 /api/app/orderCommodity/h5CourseOrderBuy
 */

export function h5CourseOrderBuy(params) {
    return request({
        url: '/tradeService/api/app/orderCommodity/h5CourseOrderBuy',
        method: 'post',
        data: params
    })
}


/**
 * 购买课程支付
 * @param params
 * @returns {AxiosPromise}
 */
export function h5CourseOrderPay(params) {
    return request({
        closeInterceptors: true,
        url: '/tradeService/api/app/orderCommodity/h5CourseOrderPay',
        method: 'post',
        data: params
    })
}

/**
 * 学习首页-H5课程详情-购买结算-查询支付结果
 * @param params
 * @returns {AxiosPromise}
 */
export function h5QueryPayOrderResult(params) {
    return request({
        closeInterceptors: true,
        url: '/tradeService/api/app/orderCommodity/h5QueryPayOrderResult',
        method: 'post',
        data: params
    })
}

export function getVOByOperateCourseId(params) {
    return request({
        url: "/studyService/api/app/course/getVOByOperateCourseIdForApp",
        method: "post",
        data: params
    });
}
export function queryPayOrderResult(params) {
    return request({
        url: "/tradeService/api/app/orderCommodity/queryPayOrderResult",
        method: "post",
        data: params
    });
}




// couponId	integer($int64)
// 优惠券Id
//
// courseId	integer($int64)
// 课程id
//
// openId	string
// openId微信H5结算必传
//
// orderPayType	integer($int32)
// 支付方式1：微信二位码支付2：微信支付app支付3：微信公众号支付4：微信H5支付5：支付宝app支付6：支付宝二微码7:支付宝WAP支付8:账户余额支付9:苹果支付
//
// realPayAmount	number
// 实际支付提交金额
//
// userId	integer($int64)
// 用户id
